export const filterPaymentMethods = (item) => {
  // New: use category field from flat API response
  if (item.category === 'bankcard') {
    return false;
  }
  // Legacy fallback for any remaining old-format items
  if (typeof item.type === 'string' && ['debit', 'credit'].indexOf(item.type.toLowerCase()) !== -1) {
    return false;
  }
  return true;
};
